import CloseIcon from '@mui/icons-material/Close'
import { Box, Tooltip } from '@mui/material'
import { createColumnHelper } from '@tanstack/react-table'
import { PermissionType } from 'api/models/Common/JyrneyEnums'
import {
  DelegatePermission,
  DelegatorPermission,
  User,
} from 'api/models/User.type'

type delegatesFlat = {
  permissionTypeName: string
  delegateFirstName: string
  delegateLastName: string
  delegateEmail: string
  delegateId: number
  delegateStartDateTime?: string
  delegateEndDateTime?: string
  removeDelegate?: func
}

type additionalData = {
  delegatesFlat: delegatesFlat
}

const getDelegateColumnsCA = () => {
  const columnHelper = createColumnHelper<User & additionalData>()

  const userTableColumns = [
    columnHelper.accessor(
      (row) => {
        console.log(row)
        return `${row.lastName}, ${row.firstName} (${row.email})`
      },
      {
        id: 'User',
      },
    ),
    columnHelper.accessor(
      (row) => {
        return `${row.delegatesFlat.delegateLastName}, ${row.delegatesFlat.delegateFirstName} (${row.delegatesFlat.delegateEmail})`
      },
      {
        id: 'Delegate',
      },
    ),
    columnHelper.accessor(
      (row) => {
        return PermissionType[
          row.delegatesFlat.permissionTypeName as keyof typeof PermissionType
        ]
      },
      {
        id: 'Permission',
      },
    ),
    columnHelper.accessor(
      (row) => {
        return row.delegatesFlat.delegateStartDateTime
          ? new Date(row.delegatesFlat.delegateStartDateTime).toLocaleString(
              'en-GB',
              {
                day: '2-digit',
                month: 'short',
                year: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
              },
            )
          : undefined
      },
      {
        id: 'Start Date',
        enableSorting: false,
      },
    ),
    columnHelper.accessor(
      (row) => {
        return row.delegatesFlat.delegateEndDateTime
          ? new Date(row.delegatesFlat.delegateEndDateTime).toLocaleString(
              'en-GB',
              {
                day: '2-digit',
                month: 'short',
                year: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
              },
            )
          : undefined
      },
      {
        id: 'End Date',
        enableSorting: false,
      },
    ),
    columnHelper.display({
      id: 'Actions',
      cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
          title="Remove delegate from user"
          onClick={() => {
            row.original.delegatesFlat.removeDelegate(
              row.original.id,
              row.original.delegatesFlat.delegateId,
            )
          }}
        >
          <Tooltip title="Remove permission">
            <CloseIcon sx={{ color: 'red' }} />
          </Tooltip>
        </Box>
      ),
    }),
  ]

  return { userTableColumns }
}

const getDelegateColumnsUser = (deleteDelegateFromUser: any) => {
  const columnHelper = createColumnHelper<DelegatePermission>()

  const userTableColumns = [
    columnHelper.accessor(
      (row) => {
        console.log('user row', row)
        return `${row.delegate.lastName}, ${row.delegate.firstName} (${row.delegate.email})`
      },
      {
        id: 'User',
      },
    ),
    columnHelper.accessor(
      (row) => {
        return PermissionType[
          row.permissionTypeName as keyof typeof PermissionType
        ]
      },
      {
        id: 'Permission Type',
      },
    ),
    columnHelper.accessor(
      (row) => {
        return row.startDateTime
      },
      {
        id: 'Start Date',
        enableSorting: false,
      },
    ),
    columnHelper.accessor(
      (row) => {
        return row.endDateTime
      },
      {
        id: 'End Date',
        enableSorting: false,
      },
    ),
    columnHelper.display({
      id: 'Actions',
      cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
          title="Remove delegate"
          onClick={() => {
            console.log(row)
            deleteDelegateFromUser(row.original.delegate.delegateId)
          }}
        >
          <Tooltip title="Remove permission">
            <CloseIcon sx={{ color: 'red' }} />
          </Tooltip>
        </Box>
      ),
    }),
  ]

  return { userTableColumns }
}

const getDelegatorColumnsUser = () => {
  const columnHelper = createColumnHelper<DelegatorPermission>()

  const userTableColumns = [
    columnHelper.accessor(
      (row) => {
        console.log('user row', row)
        return `${row.delegator.lastName}, ${row.delegator.firstName} (${row.delegator.email})`
      },
      {
        id: 'User',
      },
    ),
    columnHelper.accessor(
      (row) => {
        return PermissionType[
          row.permissionTypeName as keyof typeof PermissionType
        ]
      },
      {
        id: 'Permission Type',
      },
    ),
    columnHelper.accessor(
      (row) => {
        return row.startDateTime
      },
      {
        id: 'Start Date',
        enableSorting: false,
      },
    ),
    columnHelper.accessor(
      (row) => {
        return row.endDateTime
      },
      {
        id: 'End Date',
        enableSorting: false,
      },
    ),
  ]

  return { userTableColumns }
}

export { getDelegateColumnsCA, getDelegateColumnsUser, getDelegatorColumnsUser }
